import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { APP_CONFIG } from '@amplabs/services/config.service';

@NgModule()
export class AmplabsModule
{
    constructor(@Optional() @SkipSelf() parentModule: AmplabsModule)
    {
        if ( parentModule )
        {
            throw new Error('AppLabsModule is already loaded. Import it in the AppModule only!');
        }
    }

    static forRoot(config): ModuleWithProviders<AmplabsModule>
    {
        return {
            ngModule : AmplabsModule,
            providers: [
                {
                    provide : APP_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
